import { render } from "./base-textarea.vue?vue&type=template&id=43ed959a&ts=true"
import script from "./base-textarea.vue?vue&type=script&lang=ts"
export * from "./base-textarea.vue?vue&type=script&lang=ts"

import "./base-textarea.vue?vue&type=style&index=0&id=43ed959a&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__